module.exports = __webpack_public_path__ + "static/media/google-play-store-btn.a431f769.png";